import { FC, useState } from 'react'
import { Icon, Spin } from 'antd'
import { LoadingAndErrors } from '../../../../../components/custom_components/LoadingAndErrors'
import { useTranslation } from 'react-i18next'
import PerButton from '../../../../../components/custom_components/Button'
import useEmployeeGecoProjectBookings from '../../../../../graphql/employee/hooks/useEmployeeGecoProjectBookings'
import { GecoBookingsModal } from './GecoBookingsModal'
import { GecoProjectRow } from './GecoProjectRow'
import PerText from '../../../../../components/custom_components/Text'
import { AppraisalSeasonDto } from '../../../../../types'

type GecoAtAGlanceProps = {
  employeeId: string
  projectDisplayLimit: number
  as: AppraisalSeasonDto
  appraisalUpdate: boolean
}

export const GecoAtAGlance: FC<GecoAtAGlanceProps> = ({ employeeId, projectDisplayLimit, as, appraisalUpdate }) => {
  const [t] = useTranslation()
  const [open, setOpen] = useState(false)

  const onModalOpen = () => {
    setOpen(true)
  }

  const onCancel = () => {
    setOpen(false)
  }

  const { data, error, loading } = useEmployeeGecoProjectBookings(employeeId, as, appraisalUpdate)

  if (loading || !data) {
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />
    return <Spin className="appraisal-teaser-info" size={'large'} indicator={antIcon} tip="Loading your projects..." />
  }
  if (error) {
    return <LoadingAndErrors isLoading={loading} error={error} />
  }
  if (data.mostBookedGecoProjectsOfEmployee.length === 0) {
    return <PerText color="secondary">{t('appraisalMeeting.stepOverview.pageDescriptionProjects.noProjectsMessage')}</PerText>
  }

  const otherPercentage =
    data.mostBookedGecoProjectsOfEmployee.length > projectDisplayLimit
      ? data.mostBookedGecoProjectsOfEmployee
          .filter((project) => project.id > projectDisplayLimit - 2)
          .map((project) => project.bookedTimeInPercent)
          .reduce((projectPercentA, projectPercentB) => projectPercentA + projectPercentB)
      : 0

  return (
    <div>
      <GecoBookingsModal open={open} onCancel={onCancel} projects={data.mostBookedGecoProjectsOfEmployee} />

      {data.mostBookedGecoProjectsOfEmployee.length <= projectDisplayLimit ? (
        data.mostBookedGecoProjectsOfEmployee
          .filter((project) => project.id <= projectDisplayLimit)
          .map((project) => {
            return <GecoProjectRow key={project.id} label={project.projectName} percent={project.bookedTimeInPercent} color={project.id} />
          })
      ) : (
        <>
          {data.mostBookedGecoProjectsOfEmployee
            .filter((project) => project.id <= projectDisplayLimit - 2)
            .map((project) => {
              return (
                <GecoProjectRow key={project.id} label={project.projectName} percent={project.bookedTimeInPercent} color={project.id} />
              )
            })}
          <GecoProjectRow
            label={t('appraisalMeeting.stepOverview.pageDescriptionProjects.otherBarText')}
            percent={otherPercentage}
            color={projectDisplayLimit - 1}
          />
        </>
      )}
      <PerButton
        color="secondary"
        text={t('appraisalMeeting.stepOverview.pageDescriptionProjects.button')}
        size="small"
        onClick={() => onModalOpen()}
      />
    </div>
  )
}
